/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

import * as shape from "d3-shape";
import {MatSnackBar} from "@angular/material/snack-bar";
import {IErrorObject} from "../../../../../types/platform/universe";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-bar-chart",
	templateUrl: "./bar-chart.component.html",
	styleUrls: ["../floating/floating.component.css", "./bar-chart.component.css"],
})
export class BarChartComponent extends FloatingComponent implements OnInit, OnChanges {

	@Input() public locked: boolean = false;
	@Input() public width: number = 0;
	@Input() public height: number = 0;
	@Input() public shot: any[] = [];
	@Input() public size: number[] = [];

	public yScaleMax: number = 0;
	public yScaleMin: number = 0;
	public lineChartXAxisLabel: string = "";
	public lineChartYAxisLabel: string = "";

	public progress: boolean = false;

	public title: string = "Bar Chart";

	public lineCharts: any = null;

	public lineChartsSelected: any[] = [];

	@Output() public progrssChange = new EventEmitter<boolean>();

	public lineChartColorScheme = {
		domain: ["#2F74FF", "#039914", "#FF6759", "#FFFD77", "#9B77FF", "#5FF6FF", "#A0FF4A", "#FF79D5", "#FF9A41", "#FFD4F6"],
	};

	public lineChartLineInterpolation = shape.curveCatmullRom;

	constructor(
		protected change: ChangeDetectorRef,
		protected matDialog: MatDialog,
		protected snackbar: MatSnackBar,
		private router: Router,
		public translate: TranslateService,
	) {
		super();
	}

	/**
	 * @returns none
	 */
	private messageDialog(title: string, message: string, code: string, callback: (result: any) => void = (result:any) => {}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error:IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {

	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "shot":
					this.draw(changes.shot.currentValue);
					break;
				default:
			}
		});
	}

	/**
	 * @returns none
	 */
	public onResize(event: any): void {

	}

	/**
	 * @returns none
	 */
	public onSelect(event: any): void {

	}

	/**
	 * @returns none
	 */
	public onChange(event: any): void {
		this.lineChartsSelected = event.value;
	}

	/**
	 * @returns none
	 */
	public transform(shot: any): { y_label: string, data: any[] } {
		const result: any = {y_label: "", data: []};
		let list = [];
		if (shot) {
			if (shot.prizm) {
				list = shot.prizm.DataList;

				const ヘッドスピード: number = list[4].Value;
				const ボール初速: number = list[5].Value;

				result.y_label = list[4].Unit;
				result.data = [
					{
						"name": "ヘッドスピード",
						"value": ヘッドスピード
					},
					{
						"name": "ボール初速",
						"value": ボール初速
					}
				];
			}
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public draw(shot: any): void {
		this.Progress(true);
		try {
			const result = this.transform(shot);
			this.lineChartYAxisLabel = result.y_label;
			this.shot = result.data;
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}
